// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__2XJJ4","header":"style_header__1fRix","warningLink":"style_warningLink__Hs97j","searchBar":"style_searchBar__2ZYbd","main":"style_main__3tgAG"};